<template>
  <section class="newTable">
    <table class="table datatable table-striped area-list-datatable" id="SuspensionCareTable">
      <thead>
        <tr>
          <th :width="screenWidth * 0.08">
            <div class="checkbox checkbox-inline mr-0">
              <input
                @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
                type="checkbox"
                name="check-all"
                id="check-all"
                value="1"
                v-model="checkAll"
              />
              <label for="check-all"></label>
            </div>
            <span>#</span>
          </th>
          <th
            :width="screenWidth * 0.09"
            :class="'sorting ' + (order.fieldName == 'id' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('id')"
          >要保人ID</th>
          <th :width="screenWidth * 0.09">要保人姓名</th>
          <th :width="screenWidth * 0.09">被保人姓名</th>
          <th
            :width="screenWidth * 0.1"
            :class="'sorting ' + (order.fieldName == 'plcno' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('plcno')"
          >
            保單號碼
            <br />(契約效力)
          </th>
          <th :width="screenWidth * 0.13">險別名稱</th>
          <th
            :width="screenWidth * 0.08"
            :class="'sorting ' + (order.fieldName == 'lps_date' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('lps_date')"
          >停效日期</th>
          <th :width="screenWidth * 0.08">整合地址</th>
          <th
            :width="screenWidth * 0.1"
            :class="'sorting ' + (order.fieldName == 'reply' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('reply')"
          >完成狀態</th>
          <th width="*">排訪結果說明</th>
        </tr>
      </thead>
      <tbody class="block-height" :style="{height: height + 'px'}">
        <tr v-for="(d, did) in tableDataBackup" :key="`SuspensionCareTable-table-td-${d.id}`">
          <td :width="screenWidth * 0.08">
            <div style="min-height: 30px;">
              <div class="mr-0 checkbox checkbox-inline">
                <input
                  @click="clickTarget = clickTarget == `td-${did}`? `td-${did}-again`: `td-${did}`"
                  type="checkbox"
                  name="`td-item[]`"
                  :id="`SuspensionCareTable-check-${did}`"
                  :value="d.id"
                  v-model="selection"
                  :disabled="d.id === ''"
                  @change="$emit('update', selection)"
                />
                <label :for="`SuspensionCareTable-check-${did}`"></label>
              </div>

              <span>
                <span class="no">{{did + 1}}</span>
                <span class="info text-center">
                  <level :lv="Number(d.vip_lv)" />
                  <avatar :gender="Number(d.sex)" :size="20" />
                </span>
              </span>
            </div>
          </td>
          <td :width="screenWidth * 0.09">{{d.id | getMaskID}}</td>
          <td :width="screenWidth * 0.09">
            <Tooltip :position="did < 3 ?'bottom':'top'" :name="d.name" :id="d.id">
              <a
                v-if="d.is_exist"
                @click.prevent="routerToCust(d.id, d.name)"
                class="link text-underline"
              >{{d.name | getMaskName}}</a>
              <a v-else>{{d.name | getMaskName}}</a>
            </Tooltip>
          </td>
          <td :width="screenWidth * 0.09">{{d.insd_name | getMaskName}}</td>
          <td :width="screenWidth * 0.1">
            <span>{{d.plcno}}</span>
            <br />
            <span>{{d.fet_code}}</span>
          </td>
          <td :width="screenWidth * 0.13">{{d.prod_id}}{{d.pl_name}}</td>
          <td :width="screenWidth * 0.08">{{d.lps_date | dateFormat}}</td>
          <td :width="screenWidth * 0.08">
            <a class="link text-underline" @click="openAddressModal(d.id, d.name)">查詢</a>
          </td>
          <td :width="screenWidth * 0.1">
            <span>{{d.reply}}</span>
          </td>
          <td width="*">
            <button type="button" class="btn btn-primary" @click="$emit('visit-result-modal', d)">
              <span style="font-size:1rem">進入填寫</span>
            </button>
          </td>
        </tr>
        <tr v-if="tableDataBackup.length == 0">
          <td colspan="8" class="text-center pt-3 pb-5">
            <h3>無客戶名單資料</h3>
          </td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
        </tr>
      </tbody>
    </table>
    <!-- 整合地址查詢 -->
    <index-integrated-address-modal
      :open="IndexIntegratedAddressModalOpen"
      :address-data="addressData"
      @close="panelClose('IndexIntegratedAddressModalOpen')"
    />
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Level from "@/components/Level";
import Avatar from "@/components/Avatar";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
import moment from "moment";
import Tooltip from "@/desktop/components/ToolTip";
import { queryBelowEstrangePolicyContactInfo } from "@/service";
import IndexIntegratedAddressModal from "../../IndexIntegratedAddressModal";
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad
let idmarkWidth = 148;
if (is_iPad) {
  idmarkWidth = 131;
}

export default {
  name: "SuspensionCareTable",
  mixins: [commonMixin],
  components: { Level, Avatar, Tooltip, IndexIntegratedAddressModal },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    height: {
      type: Number,
      default: () => {
        return 350;
      }
    }
  },
  data() {
    return {
      order: {
        fieldName: "name",
        asc: true
      },
      dtData: [],
      checkAll: false,
      IndexIntegratedAddressModalOpen: false,
      addressData: {},
      clickTarget: "",
      tableDataBackup: [],
      allIdData: [],
      selection: [],
      currentWidth: 0,
      is_iPad: is_iPad,
      iPadWidth: idmarkWidth,
      postUrl: "",
      today: "",
      screenWidth:
        document.body.clientWidth > 1208 ? 1280 : document.body.clientWidth,
      scrollHeight: 0
    };
  },
  watch: {
    tableData: function() {
      this.init();
    },
    clickTarget: function(target) {
      if (target == "clickAll" || target == "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.allIdData.forEach(data => {
            this.selection.push(data);
          });
        } else {
          //取消全選
          this.selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.allIdData.length;
      }
      this.$emit("update", this.selection);
    }
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === "box";
    }
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    dateFormat(val) {
      // 轉換為民國
      if (val) {
        let dataAry = val.split("-");
        dataAry[0] = dataAry[0] * 1 - 1911 + "";
        return dataAry.join("-");
      }
      return "";
    },
    columnSorting(fieldName) {
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.fieldName = fieldName;
        this.order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }
      switch (fieldName) {
        case "name":
          this.tableDataBackup = [];
          this.$emit("get-Data", sortOrder);
          break;
        case "lps_date":
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.dateCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // for 難字更新
          }, 20);
          break;
        default:
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.sortCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // for 難字更新
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    dateCompareFun(sortOrder, property) {
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    routerToCust(custID, custName) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(custID, custName);
      } else {
        this.updateCustID(custID);
        localStorage.CustID = custID;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    init() {
      this.checkAll = false;
      this.selection = [];
      this.today = moment().format("YYYY-MM-DD");
      this.tableDataBackup = this.tableData.map(ele => {
        return ele;
      });
      this.allIdData = this.tableData.map(ele => {
        return ele.id;
      });
      // for 難字更新
      this.columnSorting('id');
      this.registerHanlink();
    },
    openAddressModal(custId, custName) {
      //  打開整合地址
      this.subsLoading = true;
      queryBelowEstrangePolicyContactInfo(
        this.$store.state.userInfo.id,
        custId,
        custName
      ).then(result => {
        this.subsLoading = false;
        if (result && result.header.status == "200" && result.body) {
          let iaaData = result.body.detail || {};
          if (result.body.detail) {
            //整理顯示內容
            iaaData.mobile = iaaData.mobl_no || ""; //手機號碼
            iaaData.mobile_update = "";
            iaaData.homeTel =
              (iaaData.htel_area ? iaaData.htel_area + "-" : "") +
              (iaaData.htel_num ? iaaData.htel_num : "") +
              (iaaData.htel_ext ? "#" + iaaData.htel_ext : ""); //住家電話號碼
            iaaData.tel_h_update = "";
            iaaData.corpTel =
              (iaaData.ctel_area ? iaaData.ctel_area + "-" : "") +
              (iaaData.ctel_num ? iaaData.ctel_num : "") +
              (iaaData.ctel_ext ? "#" + iaaData.ctel_ext : ""); //公司電話號碼
            iaaData.tel_o_update = "";
            iaaData.addressData = "";
            iaaData.tel_p_update = "";
            iaaData.feeAdd = [
              iaaData.addr_p_postal_cd ? iaaData.addr_p_postal_cd.trim() : "",
              iaaData.addr_p_city_nm ? iaaData.addr_p_city_nm.trim() : "",
              iaaData.addr_p_line_1 ? iaaData.addr_p_line_1.trim() : "",
              iaaData.addr_p_line_2 ? iaaData.addr_p_line_2.trim() : ""
            ]; //收費地址
            iaaData.censusAdd = [
              iaaData.addr_h_postal_cd ? iaaData.addr_h_postal_cd.trim() : "",
              iaaData.addr_h_city_nm ? iaaData.addr_h_city_nm.trim() : "",
              iaaData.addr_h_line_1 ? iaaData.addr_h_line_1.trim() : "",
              iaaData.addr_h_line_2 ? iaaData.addr_h_line_2.trim() : ""
            ]; //戶籍地址
            iaaData.contactAdd = [
              iaaData.addr_c_postal_cd ? iaaData.addr_c_postal_cd.trim() : "",
              iaaData.addr_c_city_nm ? iaaData.addr_c_city_nm.trim() : "",
              iaaData.addr_c_line_1 ? iaaData.addr_c_line_1.trim() : "",
              iaaData.addr_c_line_2 ? iaaData.addr_c_line_2.trim() : ""
            ]; //聯絡地址
            iaaData.email_update_date = "";
            this.addressData = iaaData;
          }
          this.addressData.isRemoteDocumentWarningShow = true;
        }
        this.registerHanlink();
        this.panelOpen("IndexIntegratedAddressModalOpen");
      });
    }
  },
  mounted() {
    // 監聽視窗寬度
    const self = this;

    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth > 1220) {
          window.screenWidth = 1220;
          self.screenWidth = 1220;
        } else {
          window.screenWidth = document.body.clientWidth;
          self.screenWidth = window.screenWidth;
        }
      })();
    };

    this.scrollHeight =
      parseInt($(window).height()) - $("tbody").offset().top - 85;
    $(window).bind("resize", function() {
      self.scrollHeight =
        parseInt($(window).height()) - $("tbody").offset().top - 85;
    });
    $(".tab-content").css("padding-bottom", "62px");
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>
